/* eslint-disable import/no-unresolved,react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';
import { isIOS } from 'react-device-detect';
import QRCode from 'react-qr-code';
import { MAIN_ICON_COLORS, SecurityTOTPBodyLayout } from 'assets/components';

import { TOTP_SECRET } from '../queries';
import { GenericLoading } from '../../../components/Placeholders';
import Input from '../../../components/Input';
import { copyToClipboard } from '../../../utilities/helpers';
import Icon from '../../../components/Icon';
import { ICONS } from '../../../components/Icon/constants';
import { ACTIONS_AFTER_RESET_SECRET } from '../constants';

const SecurityTOTPScan = () => {
  const { t: translate } = useTranslation();

  const history = useHistory();
  const { state } = useLocation();

  const [secretObj, setSecretObj] = useState({
    base32: '',
    qrCode: '',
  });

  const { isLoading: isLoadingSecret, refetch: refetchSecret } = useQuery(TOTP_SECRET, {
    enabled: false,
    onSettled: (data, error) => {
      if (!error) {
        setSecretObj({ base32: data?.base32, qrCode: data?.qr_code_url });
      }
    },
  });

  useEffect(() => {
    if (!state?.email && !state?.username) {
      history.push('/onboarding/login');
    } else if (state?.action !== ACTIONS_AFTER_RESET_SECRET.RESET_PASSWORD) {
      refetchSecret();
    } else if (state?.action === ACTIONS_AFTER_RESET_SECRET.RESET_PASSWORD) {
      setSecretObj({ base32: state?.secretBase32, qrCode: state?.secretQeCodeUrl });
    }
  }, []);

  const renderButtons = () => (
    <button
      className="btn btn-primary w-100 py-3 text-bold"
      onClick={() => {
        history.push(`/onboarding/totp-secret-save`, {
          ...state,
          secret: secretObj?.base32,
        });
      }}
      type="button">
      {translate('generic_next')}
    </button>
  );

  return (
    <SecurityTOTPBodyLayout
      title={translate('totp_step_2_title')}
      renderButtons={renderButtons}
      withBack={!state?.resetSecretKey}
      onPrevClick={history.goBack}>
      <p className="text-dark text-f5 mt-4">{translate('totp_secret_suptitle')}</p>
      {(isLoadingSecret || !secretObj?.base32 || !secretObj?.qrCode) && (
        <GenericLoading isFullScreen={false} />
      )}
      {!isLoadingSecret && secretObj?.base32 && secretObj?.qrCode && (
        <>
          <div className="d-flex flex-column justify-content-center align-items-center my-4 pt-2 pt-md-0">
            <div className="bg-white p-2 rounded-normal">
              <QRCode value={secretObj?.qrCode || ''} size={150} level="M" bgColor="#ffffff" />
            </div>
          </div>
          <p className="text-shadow text-f5 mt-4 pt-3 pe-5">{translate('totp_scan_note')}</p>
          <Input
            groupClassName={`mb-0 ${isIOS ? 'ios' : ''}`}
            type="text"
            className={`form-control-input bg-light pe-5 ${isIOS ? 'ios' : ''}`}
            placeholder={translate('totp_secret_code_placeholder')}
            label={translate('totp_secret_code_placeholder')}
            name="secret"
            value={secretObj?.base32}
            required
            readOnly
            withFloatingLabel
            inputGroupChildren={
              <>
                <div
                  className="icon position-absolute"
                  role="button"
                  onClick={() => copyToClipboard(secretObj?.base32)}
                  onKeyDown={null}
                  tabIndex={-1}
                  aria-label="Copy to Clipboard">
                  <Icon icon={ICONS.CLIPBOARD} color={MAIN_ICON_COLORS.SHADOW} />
                </div>
              </>
            }
          />
        </>
      )}
    </SecurityTOTPBodyLayout>
  );
};

export default SecurityTOTPScan;
